// Module
var code = "<svg viewBox=\"0 0 37 36\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.452 17.617 14.879 8.56a.494.494 0 0 0-.728 0 .563.563 0 0 0 0 .768L22.36 18l-8.208 8.67a.563.563 0 0 0 0 .769.489.489 0 0 0 .724 0l8.573-9.057a.562.562 0 0 0 .004-.765z\"/></svg>";
// Exports
module.exports = code;